/**
 * Products Page
 * Full products listing
 */

import React, { useState } from 'react';
import { usePortal } from '../context/PortalContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import RequestQuoteModal from '../components/RequestQuoteModal';
import { FileText } from 'lucide-react';

const ProductsPage = () => {
  const { products, branding, loading } = usePortal();
  const [quoteTarget, setQuoteTarget] = useState(null);

  if (loading) {
    return (
      <div className="loading">
        <div className="loading-spinner" />
      </div>
    );
  }

  return (
    <>
      <Header />
      
      <main style={{ marginTop: '80px', minHeight: '80vh' }}>
        <section className="section">
          <div className="container">
            <div className="masthead">
              <span className="eyebrow">Shop</span>
              <h1>Products</h1>
              <p>Browse our complete collection</p>
            </div>

            {products.length === 0 ? (
              <p style={{ textAlign: 'center', color: '#666' }}>
                No products available yet.
              </p>
            ) : (
              <div className="grid grid-3">
                {products.map(product => (
                  <div key={product.id} className="card">
                    {product.primaryImage && (
                      <img 
                        src={product.primaryImage} 
                        alt={product.name} 
                        className="card-image"
                      />
                    )}
                    <div className="card-content">
                      <h3 className="card-title">{product.name}</h3>
                      <p className="card-description">
                        {product.shortDescription || product.description?.substring(0, 150)}
                      </p>
                      {Array.isArray(product.quantityPricing) && product.quantityPricing.length > 0 && (
                        <div style={styles.tierList}>
                          {[...product.quantityPricing]
                            .sort((a, b) => a.minQty - b.minQty)
                            .map((t) => (
                              <span key={t.minQty}>Buy {t.minQty}+: ${t.price} each</span>
                            ))}
                        </div>
                      )}
                      <div style={styles.footer}>
                        <span className="card-price">${product.price?.toFixed(2)} each</span>
                        {/* Straight into the instant order form with this garment picked (2026-09-28). */}
                        <a
                          href={`/print-order?product=${product.id}`}
                          style={{ ...styles.addBtn, background: branding.primaryColor, width: 'auto', borderRadius: 999, padding: '0 14px', color: 'white', textDecoration: 'none', fontSize: 13, fontWeight: 700 }}
                        >
                          Order now
                        </a>
                        <button
                          type="button"
                          onClick={() => setQuoteTarget({ type: 'product', id: product.id, name: product.name })}
                          style={{ ...styles.addBtn, background: branding.primaryColor }}
                          title="Request a Quote"
                        >
                          <FileText size={18} />
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />

      {quoteTarget && <RequestQuoteModal target={quoteTarget} onClose={() => setQuoteTarget(null)} />}
    </>
  );
};

const styles = {
  tierList: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '12px',
    color: '#888',
    marginTop: '8px',
    gap: '2px',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '15px',
  },
  addBtn: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    border: 'none',
    color: 'white',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export default ProductsPage;
